import Box from "@mui/material/Box";
import { Grid2 as Grid, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import DashboardCard from "../../components/dashboard/dashboardCard";
import { ReactComponent as ProfileIcon } from "../../assets/accountDashboard/profileIcon.svg";
import { ReactComponent as CouponIcon } from "../../assets/accountDashboard/couponIcon.svg";
import { ReactComponent as HistoryIcon } from "../../assets/accountDashboard/historyIcon.svg";
import { ReactComponent as LocationIcon } from "../../assets/accountDashboard/locationIcon.svg";
import { ReactComponent as ReturnIcon } from "../../assets/accountDashboard/returnIcon.svg";
import { ReactComponent as ProveIcon } from "../../assets/accountDashboard/proveIcon.svg";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { DASHBOARD } from "../../locales/components/namespaces";
import { userLogout } from "../../actions/currentUser/actions";

const Dashboard = () => {
  const { t } = useTranslation(DASHBOARD);
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(userLogout());
  };

  // Array με τα cards και τα links τους
  const dashboardItems = [
    {
      title: t("accountDetails"),
      icon: ProfileIcon,
      link: "/account/details",
    },
    {
      title: t("orderHistory"),
      icon: HistoryIcon,
      link: "/account/order/history",
    },
    // {
    //   title: t("productReturns"),
    //   icon: ReturnIcon,
    //   link: "/account/returns",
    // },
    // {
    //   title: t("receiptProof"),
    //   icon: ProveIcon,
    //   link: "/account/proof",
    // },
    {
      title: t("addresses"),
      icon: LocationIcon,
      link: "/account/addresses",
    },
    // {
    //   title: t("coupons"),
    //   icon: CouponIcon,
    //   link: "/account/coupons",
    // },
  ];

  return (
    <Box sx={{
        padding: "20px",
        maxWidth: 1720,
        margin: "3rem auto 0" }}>
      <Box sx={{ marginBottom: "40px" }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 900,
            fontSize: "48px",
            lineHeight: "90%",
            marginBottom: "16px",
            fontFamily: "Zen Maru Gothic",
          }}
        >
          {t("title")}
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontSize: "16px",
              color: "#000000ff",
              fontWeight: 400,
              lineHeight: "120%",
              fontFamily: "Roboto",
              flex: 1,
            }}
          >
            {t("subtitle")}
          </Typography>

          <Button
            variant="outlined"
            onClick={handleLogout}
            sx={{
              padding: "10px 24px",
              border: "2px solid #E5007E",
              color: "#E5007E",
              fontFamily: "Zen Maru Gothic",
              fontWeight: 600,
              fontSize: "14px",
              whiteSpace: "nowrap",
              flexShrink: 0,
              borderRadius: "24px",
              transition: "all 0.3s ease",
              backgroundColor: "transparent",

              "&:hover": {
                backgroundColor: "#E5007E",
                color: "#ffffff",
                borderColor: "#E5007E",
              },
            }}
          >
            {t("logout")}
          </Button>
        </Box>
      </Box>

      {/* Grid Layout 3 columns */}
      <Grid container spacing={5}>
        {dashboardItems.map((item, index) => (
          <Grid key={index} size={{ xs: 12, sm: 6, md: 4 }}>
            <Link
              to={item.link}
              style={{
                textDecoration: "none",
                  display: "block",
                  height: "100%",
              }}
            >
              <DashboardCard title={item.title} icon={item.icon} />
            </Link>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Dashboard;
